// Level thresholds (total XP required to reach each level):
export const levelThresholds = [0, 100, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000, 250000, 500000, 1000000];

// XP award per rarity (or per resource click):
export const xpAward = {
  common:   5,
  uncommon: 10,
  rare:     25,
  unique:   100,
};
